import { GenieQuickTestModal, PronunciationModal, QRCodeModal, WebEmbedModal, webEmbedTabFor } from "@/components/agent";
import { SimpleOverview } from "@/components/agent/core/SimpleOverview";
import AdvancedSettingsDrawer from "@/components/agent/drawers/AdvancedSettingsDrawer";
import ConversationDrawer from "@/components/agent/drawers/ConversationDrawer";
import GenieInsightsDrawer from "@/components/agent/drawers/GenieInsightsDrawer";
import GeniePromptDrawer from "@/components/agent/drawers/GeniePromptDrawer";
import GenieShareDrawer from "@/components/agent/drawers/GenieShareDrawer";
import IdentityDrawer from "@/components/agent/drawers/IdentityDrawer";
import KnowledgeDrawer from "@/components/agent/drawers/KnowledgeDrawer";
import { BrandingModal } from "@/components/branding";
import { PhoneNumberModal } from "@/components/phone";
import { Agent } from "@/types/agent/agent";
import NotificationsDrawer from "../drawers/NotificationsDrawer";
import { GenieActionModal } from "./GenieActionsPanel";

interface GenieModalsProps {
  genie: Agent;
  activeModal: GenieActionModal | null;
  onClose: () => void;
  onSwitchModal?: (modal: GenieActionModal) => void;
}

export const GenieModals = ({ genie, activeModal, onClose, onSwitchModal }: GenieModalsProps) => (
  <>
    <GenieQuickTestModal genie={genie} isOpen={activeModal === "quickTest"} onClose={onClose} />
    <GenieShareDrawer
      genie={genie}
      isOpen={activeModal === "shareDrawer"}
      onClose={onClose}
      onOpenPhoneModal={onSwitchModal ? () => onSwitchModal("phone") : undefined}
    />
    <SimpleOverview genie={genie} isOpen={activeModal === "simpleDetails"} onClose={onClose} />
    <GeniePromptDrawer genie={genie} isOpen={activeModal === "prompt"} onClose={onClose} />
    <GenieInsightsDrawer genie={genie} isOpen={activeModal === "insightsDrawer"} onClose={onClose} />
    <KnowledgeDrawer genie={genie} isOpen={activeModal === "knowledge"} onClose={onClose} />
    <PronunciationModal genie={genie} isOpen={activeModal === "pronunciation"} onClose={onClose} />
    <PhoneNumberModal genie={genie} isOpen={activeModal === "phone"} onClose={onClose} />
    <WebEmbedModal
      genie={genie}
      isOpen={webEmbedTabFor(activeModal) !== null}
      initialTab={webEmbedTabFor(activeModal) ?? undefined}
      onClose={onClose}
    />
    <QRCodeModal genie={genie} isOpen={activeModal === "qr"} onClose={onClose} />
    <NotificationsDrawer genie={genie} isOpen={activeModal === "email"} onClose={onClose} />
    <BrandingModal
      key={`${genie.id}-${activeModal === "branding"}`}
      genie={genie}
      isOpen={activeModal === "branding"}
      onClose={onClose}
      onSwitchModal={onSwitchModal}
    />
    <IdentityDrawer genie={genie} isOpen={activeModal === "identity"} onClose={onClose} />
    <ConversationDrawer genie={genie} isOpen={activeModal === "conversation"} onClose={onClose} />
    <AdvancedSettingsDrawer genie={genie} isOpen={activeModal === "advanced"} onClose={onClose} />
  </>
);
